module.exports = __webpack_public_path__ + "img/720.1ea1ae23.svg";